import React, { useEffect, useMemo, useState } from 'react';
import { ImageViewer } from 'antd-mobile-v5';
import './index.scss';

import wirelessImg from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_wireless_4g.png';
import gw214Img from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_rs485_gw214.png';
import gw152Img from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_rs485_gw152.png';
import master4pImg from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_rs485_master_4p.png';
import blueGw214Img from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_blue_rs485_gw214.png';
import blueGw152Img from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_blue_rs485_gw152.png';
import blueMaster4pImg from '../../../../assets/product-interaction/ddsu5168/ddsu5168_2p_blue_rs485_master_4p.png';

const wiringDiagrams = [
  {
    id: 'wireless',
    connection: 'wireless',
    title: '无线版接线图',
    tag: 'LoRa / 4G',
    image: wirelessImg,
    imageAlt: 'DDSU5168 LoRa 和 4G 无线版本接线图'
  },
  {
    id: 'gw214',
    connection: 'wired',
    variant: 'regular',
    gateway: 'gw214',
    title: '常规款接线图',
    tag: 'GW214',
    image: gw214Img,
    imageAlt: 'DDSU5168 有线版本连接 GW214 网关接线图'
  },
  {
    id: 'gw152',
    connection: 'wired',
    variant: 'regular',
    gateway: 'gw152',
    title: '常规款接线图',
    tag: 'GW152',
    image: gw152Img,
    imageAlt: 'DDSU5168 有线版本连接 GW152 网关接线图'
  },
  {
    id: 'master4p',
    connection: 'wired',
    variant: 'regular',
    gateway: 'master4p',
    title: '常规款接线图',
    tag: '4P 母表',
    image: master4pImg,
    imageAlt: 'DDSU5168 有线版本连接 4P 母表接线图'
  },
  {
    id: 'blue-gw214',
    connection: 'wired',
    variant: 'blue',
    gateway: 'gw214',
    title: '小蓝点接线图',
    tag: 'GW214',
    image: blueGw214Img,
    imageAlt: 'DDSU5168 小蓝点有线版本连接 GW214 网关接线图'
  },
  {
    id: 'blue-gw152',
    connection: 'wired',
    variant: 'blue',
    gateway: 'gw152',
    title: '小蓝点接线图',
    tag: 'GW152',
    image: blueGw152Img,
    imageAlt: 'DDSU5168 小蓝点有线版本连接 GW152 网关接线图'
  },
  {
    id: 'blue-master4p',
    connection: 'wired',
    variant: 'blue',
    gateway: 'master4p',
    title: '小蓝点接线图',
    tag: '4P 母表',
    image: blueMaster4pImg,
    imageAlt: 'DDSU5168 小蓝点有线版本连接 4P 母表接线图'
  }
];

const connectionOptions = [
  { value: 'all', label: '全部' },
  { value: 'wireless', label: '无线' },
  { value: 'wired', label: '有线' }
];

const gatewayOptions = [
  { value: 'all', label: '全部采集器' },
  { value: 'gw214', label: 'GW214' },
  { value: 'gw152', label: 'GW152' },
  { value: 'master4p', label: '4P母表' }
];

const variantOptions = [
  { value: 'regular', label: '常规款' },
  { value: 'blue', label: '小蓝点' }
];

const CompactButtons = ({ ariaLabel, className = '', options, value, onChange }) => (
  <div className={`wiring-compact-buttons${className ? ` ${className}` : ''}`} role="group" aria-label={ariaLabel}>
    {options.map((option) => (
      <button
        type="button"
        className={value === option.value ? 'is-active' : ''}
        aria-pressed={value === option.value}
        key={option.value}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

const DDSU5168Wiring = () => {
  const [connection, setConnection] = useState('all');
  const [variant, setVariant] = useState('regular');
  const [gateway, setGateway] = useState('all');
  const [previewImage, setPreviewImage] = useState('');

  useEffect(() => {
    document.title = 'DDSU5168 接线图｜源一物联';
    window.scrollTo(0, 0);
  }, []);

  const handleConnectionChange = (value) => {
    setConnection(value);
    if (value !== 'wired') {
      setVariant('regular');
      setGateway('all');
    }
  };

  const visibleDiagrams = useMemo(() => wiringDiagrams.filter((diagram) => {
    if (connection !== 'all' && diagram.connection !== connection) {
      return false;
    }
    if (connection !== 'wired') {
      return true;
    }
    if (diagram.variant !== variant) {
      return false;
    }
    return gateway === 'all' || diagram.gateway === gateway;
  }), [connection, variant, gateway]);

  return (
    <div className="ddsu5168-wiring-shell">
      <main className="ddsu5168-wiring-page">
        <header className="wiring-toolbar">
          <a className="wiring-back" href="/product/ddsu5168" aria-label="返回 DDSU5168 产品页">
            <span aria-hidden="true">‹</span>
          </a>
          <h1>DDSU5168 接线图</h1>
        </header>

        <div className="wiring-filter-bar" aria-label="接线图筛选">
          <div className="wiring-filter-line">
            <CompactButtons
              ariaLabel="通讯版本"
              className="wiring-connection-filter"
              options={connectionOptions}
              value={connection}
              onChange={handleConnectionChange}
            />
            {connection === 'wired' && (
              <>
              <CompactButtons
                ariaLabel="产品款式"
                options={variantOptions}
                value={variant}
                onChange={setVariant}
              />
              <label className="wiring-gateway-select">
                <span className="wiring-sr-only">采集器</span>
                <select
                  aria-label="采集器"
                  value={gateway}
                  onChange={(event) => setGateway(event.target.value)}
                >
                  {gatewayOptions.map((option) => (
                    <option value={option.value} key={option.value}>{option.label}</option>
                  ))}
                </select>
                <span className="wiring-select-arrow" aria-hidden="true">⌄</span>
              </label>
              </>
            )}
          </div>
        </div>

        <section className="wiring-diagram-list" aria-live="polite">
          {visibleDiagrams.map((diagram, index) => (
            <figure
              className={`wiring-diagram wiring-diagram-${diagram.id}`}
              key={diagram.id}
            >
              <figcaption className="wiring-diagram-title">
                <span className="wiring-diagram-name">{diagram.title}</span>
                <span className="wiring-diagram-tag">{diagram.tag}</span>
              </figcaption>
              <img
                src={diagram.image}
                alt={diagram.imageAlt}
                loading={index === 0 ? 'eager' : 'lazy'}
                decoding="async"
                onClick={() => setPreviewImage(diagram.image)}
              />
            </figure>
          ))}
        </section>

        <ImageViewer
          image={previewImage}
          visible={Boolean(previewImage)}
          onClose={() => setPreviewImage('')}
        />
      </main>
    </div>
  );
};

export default DDSU5168Wiring;
